"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var classifier_data_service_1 = require("../../classifier-data.service");
var idm_classifier_service_client_js_2 = require("@synisys/idm-classifier-service-client-js");
var me_kb_http_service_1 = require("./me-kb-http.service");
var name_template_service_1 = require("../../name-template.service");
var me_config_service_1 = require("../../me-config.service");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var HttpMEClassifierService = /** @class */ (function () {
    function HttpMEClassifierService(classifierHttpService, currentLanguageProvider, messageServiceImpl, kbService, classifierDataService, meConfigService, nameTemplateService) {
        this.classifierHttpService = classifierHttpService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.messageServiceImpl = messageServiceImpl;
        this.kbService = kbService;
        this.classifierDataService = classifierDataService;
        this.meConfigService = meConfigService;
        this.nameTemplateService = nameTemplateService;
    }
    HttpMEClassifierService.prototype.loadClassifiersByIds = function (categorySystemName, filterIds, isWithChildren, paging, sorting) {
        var _this = this;
        switch (categorySystemName) {
            case 'IndicatorRepresents':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.classifierDataService.getNatures()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            case 'IndicatorContextType':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.classifierDataService.getIndicatorContextTypes()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            case 'IndicatorStatuses':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.classifierDataService.getIndicatorStatuses()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            case 'IndicatorTypes':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.classifierDataService.getIndicatorTypes()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            case 'ReportingFrequencies':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.classifierDataService.getFrequencies()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            case 'ChangeDirection':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.classifierDataService.getChangeDirections()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            case 'IndicatorDataFormatType':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.classifierDataService.getDataFormats()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            case 'IndicatorFrameworkLevel':
                return zip_1.zip(this.kbService.getMetaFields(categorySystemName), this.nameTemplateService.getNameTemplates()).pipe(operators_1.switchMap(function (data) {
                    var filteredCategories = data[1].filter(function (category) {
                        return filterIds.indexOf(category.id) !== -1;
                    });
                    return zip_1.zip.apply(void 0, _this.convertRfLevelToClassifier(data[0], filteredCategories, idm_classifier_service_client_js_1.Classifier)).pipe(operators_1.map(function (classifiers) {
                        return new idm_classifier_service_client_js_1.ClassifiersResponse(new idm_classifier_service_client_js_2.ClassifiersResponseMetaData(classifiers.length), classifiers);
                    }));
                }));
            default:
                return this.classifierHttpService.loadClassifiersByIds(categorySystemName, filterIds, isWithChildren, paging, sorting);
        }
    };
    HttpMEClassifierService.prototype.loadClassifiersView = function (categorySystemName) {
        var _this = this;
        switch (categorySystemName) {
            case 'IndicatorRepresents':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.classifierDataService.getNatures()).pipe(operators_1.switchMap(function (data) {
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            case 'IndicatorContextType':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.classifierDataService.getIndicatorContextTypes()).pipe(operators_1.switchMap(function (data) {
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            case 'IndicatorStatuses':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.classifierDataService.getIndicatorStatuses()).pipe(operators_1.switchMap(function (data) {
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            case 'IndicatorTypes':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.classifierDataService.getIndicatorTypes()).pipe(operators_1.switchMap(function (data) {
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            case 'ReportingFrequencies':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.classifierDataService.getFrequencies(), this.meConfigService.getSystemCategoryItemsFilterConfig('ReportingFrequencies')).pipe(operators_1.switchMap(function (data) {
                    if (data[2]) {
                        data[1] = data[1].filter(function (category) {
                            return data[2].indexOf(category.id) !== -1;
                        });
                    }
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            case 'ChangeDirection':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.classifierDataService.getChangeDirections()).pipe(operators_1.switchMap(function (data) {
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            case 'IndicatorDataFormatType':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.classifierDataService.getDataFormats()).pipe(operators_1.switchMap(function (data) {
                    return zip_1.zip.apply(void 0, _this.convertCategoriesToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            case 'IndicatorFrameworkLevel':
                return zip_1.zip(this.kbService.getClassifierViewMetaFields(), this.nameTemplateService.getNameTemplates()).pipe(operators_1.switchMap(function (data) {
                    return zip_1.zip.apply(void 0, _this.convertRfLevelToClassifier(data[0], data[1], idm_classifier_service_client_js_1.ClassifierView));
                }));
            default:
                return this.classifierHttpService.loadClassifiersView(categorySystemName);
        }
    };
    HttpMEClassifierService.prototype.convertCategoriesToClassifier = function (metaFields, categories, entityClass) {
        var _this = this;
        var classifiersObservables = [];
        categories.forEach(function (category) {
            classifiersObservables.push(_this.messageServiceImpl.getMessage(category.messageKey).pipe(operators_1.first(), operators_1.map(function (message) {
                var entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
                var defaultClassifier = entityBuilder.createEntity(entityClass, metaFields);
                defaultClassifier.getProperty('name').value = message;
                var metaFieldIntegerIdentity = metaFields.find(function (metaField) {
                    return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY;
                });
                metaFieldIntegerIdentity && (defaultClassifier.getProperty(metaFieldIntegerIdentity.getSystemName()).value = category.id);
                return defaultClassifier;
            })));
        });
        return classifiersObservables;
    };
    HttpMEClassifierService.prototype.convertRfLevelToClassifier = function (metaFields, frameworkLevels, entityClass) {
        var _this = this;
        var classifiersObservables = [];
        frameworkLevels.forEach(function (frameworkLevel) {
            classifiersObservables.push(_this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.first(), operators_1.map(function (language) {
                var entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
                var defaultClassifier = entityBuilder.createEntity(entityClass, metaFields);
                defaultClassifier.getProperty('name').value = frameworkLevel.name[language.getId()];
                var metaFieldIntegerIdentity = metaFields.find(function (metaField) {
                    return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY;
                });
                metaFieldIntegerIdentity && (defaultClassifier.getProperty(metaFieldIntegerIdentity.getSystemName()).value = frameworkLevel.id);
                return defaultClassifier;
            })));
        });
        return classifiersObservables;
    };
    HttpMEClassifierService.prototype.clearCache = function (categorySystemName) {
        return this.classifierHttpService.clearCache(categorySystemName);
    };
    HttpMEClassifierService.prototype.create = function (categorySystemName, classifier) {
        return this.classifierHttpService.create(categorySystemName, classifier);
    };
    HttpMEClassifierService.prototype.createDummyClassifier = function (categorySystemName) {
        return this.classifierHttpService.createDummyClassifier(categorySystemName);
    };
    HttpMEClassifierService.prototype.delete = function (categorySystemName, classifier) {
        return this.classifierHttpService.delete(categorySystemName, classifier);
    };
    HttpMEClassifierService.prototype.getAuthInfo = function (categorySystemName, id, documentSystemName) {
        return this.classifierHttpService.getAuthInfo(categorySystemName, id, documentSystemName);
    };
    HttpMEClassifierService.prototype.getCategoryLastModificationTimeInMillis = function (categorySystemName) {
        return this.classifierHttpService.getCategoryLastModificationTimeInMillis(categorySystemName);
    };
    HttpMEClassifierService.prototype.getDocumentAuthInfo = function (categorySystemName, id, documentSystemName) {
        return this.classifierHttpService.getDocumentAuthInfo(categorySystemName, id, documentSystemName);
    };
    HttpMEClassifierService.prototype.getEntityName = function (categorySystemName, entity) {
        return this.classifierHttpService.getEntityName(categorySystemName, entity);
    };
    HttpMEClassifierService.prototype.getModifiedCategories = function (modifiedAfter) {
        return this.classifierHttpService.getModifiedCategories(modifiedAfter);
    };
    HttpMEClassifierService.prototype.loadAllClassifiers = function (categorySystemName, isWithChildren, paging) {
        return this.classifierHttpService.loadAllClassifiers(categorySystemName, isWithChildren, paging);
    };
    HttpMEClassifierService.prototype.loadCategoryIconIds = function (categorySystemName, ids) {
        return this.classifierHttpService.loadCategoryIconIds(categorySystemName, ids);
    };
    HttpMEClassifierService.prototype.loadClassifier = function (categorySystemName, id, isWithChildren) {
        return this.classifierHttpService.loadClassifier(categorySystemName, id, isWithChildren);
    };
    HttpMEClassifierService.prototype.loadClassifierDependencies = function (categorySystemName, id) {
        return this.classifierHttpService.loadClassifierDependencies(categorySystemName, id);
    };
    HttpMEClassifierService.prototype.loadClassifiers = function (categorySystemName, isWithChildren, paging, sorting, filter) {
        return this.classifierHttpService.loadClassifiers(categorySystemName, isWithChildren, paging, sorting, filter);
    };
    HttpMEClassifierService.prototype.loadClassifiersByFilter = function (categorySystemName, filterCriteria, isWithChildren, paging, sorting) {
        return this.classifierHttpService.loadClassifiersByFilter(categorySystemName, filterCriteria, isWithChildren, paging, sorting);
    };
    HttpMEClassifierService.prototype.loadClassifiersByParent = function (categorySystemName, parentId, paging, sorting, filter, isWithChildren) {
        return this.classifierHttpService.loadClassifiersByParent(categorySystemName, parentId, paging, sorting, filter, isWithChildren);
    };
    HttpMEClassifierService.prototype.loadClassifiersViewByFilter = function (categorySystemName, filter) {
        return this.classifierHttpService.loadClassifiersViewByFilter(categorySystemName, filter);
    };
    HttpMEClassifierService.prototype.loadClassifiersViewByPaging = function (categorySystemName, filterCriteria, paging) {
        return this.classifierHttpService.loadClassifiersViewByPaging(categorySystemName, filterCriteria, paging);
    };
    HttpMEClassifierService.prototype.loadClassifiersViewByParent = function (categorySystemName, parentId) {
        return this.classifierHttpService.loadClassifiersViewByParent(categorySystemName, parentId);
    };
    HttpMEClassifierService.prototype.loadItemPermissions = function (categorySystemName, itemId) {
        return this.classifierHttpService.loadItemPermissions(categorySystemName, itemId);
    };
    HttpMEClassifierService.prototype.resetCaches = function (categorySystemName) {
        this.classifierHttpService.resetCaches(categorySystemName);
    };
    HttpMEClassifierService.prototype.update = function (categorySystemName, classifier) {
        return this.classifierHttpService.update(categorySystemName, classifier);
    };
    HttpMEClassifierService.prototype.validateClassifier = function (categorySystemName, classifier) {
        return this.classifierHttpService.validateClassifier(categorySystemName, classifier);
    };
    HttpMEClassifierService.prototype.validateClassifierField = function (categorySystemName, classifier, fieldSystemName) {
        return this.classifierHttpService.validateClassifierField(categorySystemName, classifier, fieldSystemName);
    };
    HttpMEClassifierService.prototype.getDocumentAuthInfoForUpload = function (categorySystemName, id, documentSystemName) {
        return this.classifierHttpService.getDocumentAuthInfoForUpload(categorySystemName, id, documentSystemName);
    };
    HttpMEClassifierService.prototype.bulkCreate = function (categorySystemName, classifiers, raiseEvent) {
        return this.classifierHttpService.bulkCreate(categorySystemName, classifiers, raiseEvent);
    };
    HttpMEClassifierService.prototype.bulkUpdate = function (categorySystemName, classifiers, raiseEvent) {
        return this.classifierHttpService.bulkUpdate(categorySystemName, classifiers, raiseEvent);
    };
    HttpMEClassifierService.prototype.bulkDelete = function (categorySystemName, ids, raiseEvent) {
        return this.classifierHttpService.bulkDelete(categorySystemName, ids, raiseEvent);
    };
    HttpMEClassifierService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierHttpService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.MessageService,
            me_kb_http_service_1.MEKbHttpService,
            classifier_data_service_1.ClassifierDataService,
            me_config_service_1.MeConfigService,
            name_template_service_1.NameTempalteService])
    ], HttpMEClassifierService);
    return HttpMEClassifierService;
}());
exports.HttpMEClassifierService = HttpMEClassifierService;
//# sourceMappingURL=http-me-classifier.service.js.map